var _jsxFileName = "/home/runner/work/frontend/frontend/libs/ui-design-system/src/assets/Features/FeatureBurger.tsx";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function SvgComponent(_ref) {
  var _ref$width = _ref.width,
    width = _ref$width === void 0 ? 20 : _ref$width,
    _ref$height = _ref.height,
    height = _ref$height === void 0 ? 20 : _ref$height,
    _ref$weight = _ref.weight,
    weight = _ref$weight === void 0 ? 2.5 : _ref$weight,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? '#222222' : _ref$color;
  return _jsxs("svg", {
    width: width,
    height: height,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [_jsx("path", {
      d: "M18 1.99988H2",
      stroke: color,
      strokeWidth: weight,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), _jsx("path", {
      d: "M18 8.99976H2",
      stroke: color,
      strokeWidth: weight,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), _jsx("path", {
      d: "M18 15.9999H2",
      stroke: color,
      strokeWidth: weight,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })]
  });
}
var MemoSvgComponent = React.memo(SvgComponent);
export default MemoSvgComponent;
//# sourceMappingURL=FeatureBurger.js.map